import { render, staticRenderFns } from "./ResetPasswordModal.vue?vue&type=template&id=be6e6806"
import script from "./ResetPasswordModal.vue?vue&type=script&lang=js"
export * from "./ResetPasswordModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/flexiquote/flexiquote/uniqms-vue-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('be6e6806')) {
      api.createRecord('be6e6806', component.options)
    } else {
      api.reload('be6e6806', component.options)
    }
    module.hot.accept("./ResetPasswordModal.vue?vue&type=template&id=be6e6806", function () {
      api.rerender('be6e6806', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/user/ResetPasswordModal.vue"
export default component.exports